import React from 'react';

const {
  tagsJson,
} = require('./tags/sendy/tags');

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const SENDYTheme = {
  headerLogo: {
    src: '/themes/theme/sendy/logo.webp',
    alt: 'Sendy',
  },
  darkLogo: {
    src: '/themes/theme/sendy/logo.webp',
    alt: 'Sendy',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #9bd4de',
  },
  linkStyle: {
    color: '#474648',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Sendy',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/sendy/logo.webp" alt="Sendy" />
    </div>
  ),
  shareSite: 'https://reports.sendy.io',
  organisationId: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: '/themes/theme/gifta/logo.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
  primaryButtonColorStyle: {
    background: '#9bd4de',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'blue',
  formTitle: () => (
    <h3 style={textAlignCentre}>Apply now</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>An Ambassador program like no other</p>
      <br />
      <p style={textAlignCentre50p}>SENDY Ambassadors will share in our success alongside our Stockholders!. We stand by, for and of the people. We ride together, we win together. Welcome to the the next generation of collaboration.</p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Thanks for signing up to SENDY.</p>
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <h5 style={textAlignCentre}>The Sendy Shares Program:</h5>
      <br />
      <p style={textAlignCentre}>How does it work? You will receive 1 Sendy Share for each $1 you make on the SENDY platform after sharing your listings on instagram. You keep the cash from the gear you sold too.</p>
      <br />
      <p style={textAlignCentre}>We have set aside a minimum Sendy Shares Pool of $500,000 to share with Ambassadors if we exit for $20 million or more. This program is limited. $5k per person and $500k total. First chair gets the pow.</p>
      <br />
    </div>
  ),
  socialHandle1HtmlTitle: () => (
    <h3 style={textAlignCentre}>Link your Gram</h3>
  ),
  socialHandle1HtmlTop: () => (
    <p style={textAlignCentre}>So we can track your insta shares and give you SENDY shares.</p>
  ),
  socialHandle1HtmlBottom: () => (
    <p style={textAlignCentre}>Every piece of gear posted on SENDY and shared to stories qualifies for the SENDY shares program.</p>
  ),
  socialHandle2HtmlTitle: () => (
    <h3 style={textAlignCentre}>You're almost there</h3>
  ),
  socialHandle3HtmlTitle: () => (
    <h3 style={textAlignCentre}>Last thing</h3>
  ),
  personalDetailHtmlTitle: () => (
    <h3 style={textAlignCentre}>This is how we get in touch</h3>
  ),
  personalDetailHtmlTop: () => (
    <p style={textAlignCentre}>We will email unique links and details about the program</p>
  ),
  personalDetailHtmlBottom: () => (
    <p style={textAlignCentre}>A dollar of gear sold on SENDY qualifies for a dollar in SENDY shares.</p>
  ),
  tagsTitle: () => (
    <p style={textAlignCentre}>What's your vibe</p>
  ),
  tagsJson,
  tAndCUrl: 'https://app.termly.io/document/terms-of-use-for-website/90d513e8-5d9e-4661-98d4-2c7c782342e0',
  ppUrl: 'https://app.termly.io/document/cookie-policy/b8d59005-fbea-48e8-909f-4a78f58e474b',
};

export default SENDYTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/sendy.js
 **/